import React, { Fragment, useRef, useState, useEffect } from 'react';
import { Tooltip } from 'bootstrap';

const STATUS_COPIED = 'copied';
const STATUS_NOT_COPIED = 'not-copied';

export default (props) => {

  const inputRef = useRef(null);
  const btnRef = useRef(null);

  const [status, setStatus] = useState(STATUS_NOT_COPIED);
  const [tooltip, setTooltip] = useState(null);

  useEffect(() => {
    setTooltip(new Tooltip(btnRef.current, { trigger: 'manual' }));
  }, []);

  useEffect(() => {
    if (status === 'copied') {
      tooltip.show();
    } else if (tooltip !== null) {
      tooltip.hide();
    }
  }, [status]);

  const copyToClipboard = () => {
    var copyText = inputRef.current;
    copyText.select();
    copyText.setSelectionRange(0, 99999); /* For mobile devices */
    document.execCommand("copy");
    setStatus(STATUS_COPIED);
  }

  const inputBlurHandler = () => {
    setStatus(STATUS_NOT_COPIED);
  }

  return (
    <div className="row g-3 align-items-center">
      <div className="col-sm-auto flex-grow-1">
        <input type="text" readOnly id="sharePublicProfileUrl" className="form-control" value={props.value} ref={inputRef} onBlur={inputBlurHandler} />
      </div>
      <div className="col-sm-auto">
        <button className="btn btn-primary" ref={btnRef} data-bs-toggle="tooltip" data-bs-placement="top" title={props.copiedMessage} onClick={copyToClipboard}>Copy to clipboard</button>
      </div>
    </div>
  );
}
